import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export type GetInventoryServerResponse = {
    content: InventoryResponseItem[]
    total_count: number
    page_size: number
}

export type InventoryResponseItem = {
    id: string
    category_id: string
    is_restockable_on_void: boolean
    is_restockable_on_refund: boolean
    low_threshold: Maybe<number>
    origin_timestamp: string
    deleted: boolean
    version: number
    inventory_item_locations: InventoryResponseItemLocation[]
}

export type InventoryResponseItemLocation = {
    id: string
    inventory_item_id: string
    location_id: string
    origin_timestamp: string
    quantity_total?: Maybe<number>
    version: 0
    deleted: boolean
}

export const getInventoryApi = (headers: Record<string, any>): Rx.Observable<GetInventoryServerResponse> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: "/data/inventory-item",
            headers: headers,
        })
    ).pipe(retry(3))
